// extracted by css-extract-rspack-plugin
export default {"select":"CalendarTimeRangeSwitch_select__MAfuY"};